import { render, staticRenderFns } from "./PlayerNote.vue?vue&type=template&id=00b8e829&"
import script from "./PlayerNote.vue?vue&type=script&lang=js&"
export * from "./PlayerNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports